module.exports = __webpack_public_path__ + "img/55.97529644.jpg";